<template>
    <div :class="containerClass ? containerClass : 'pin-input-container'">
      <div v-if="title" :class="titleClass ? titleClass : 'text-center pin-title'">
        {{ title }}
      </div>
      <div class="" style="display: flex; flex-direction: column; gap: 8px; width:fit-content;">
          <div :class="inputContainerClass ? inputContainerClass : 'pin-inputs'" style="width: fit-content;">
            <input
              ref="pin1"
              type="text"
              @focus="handleFocus"
              @paste="handlePaste"
              :style="pinStyle"
              class="pin-input"
              @input="handleInput($event, 0, 1)"
              @keydown="handleKeydown($event, 'pin1')"
            />
            <input
              ref="pin2"
              type="text"
              @focus="handleFocus"
              @paste="handlePaste"
              :style="pinStyle"
              class="pin-input"
              @input="handleInput($event, 1, 2)"
              @keydown="handleKeydown($event, 'pin2', 'pin1')"
            />
            <input
              ref="pin3"
              type="text"
              @focus="handleFocus"
              @paste="handlePaste"
              :style="pinStyle"
              class="pin-input"
              @input="handleInput($event, 2, 3)"
              @keydown="handleKeydown($event, 'pin3', 'pin2')"
            />
            <input
              ref="pin4"
              type="text"
              @focus="handleFocus"
              @paste="handlePaste"
              :style="pinStyle"
              class="pin-input"
              @input="handleInput($event, 3, 4)"
              @keydown="handleKeydown($event, 'pin4', 'pin3')"
            />
            <input
              ref="pin5"
              type="text"
              @focus="handleFocus"
              @paste="handlePaste"
              :style="pinStyle"
              class="pin-input"
              @input="handleInput($event, 4, 5)"
              @keydown="handleKeydown($event, 'pin5', 'pin4')"
            />
            <input
              ref="pin6"
              type="text"
              @focus="handleFocus"
              @paste="handlePaste"
              :style="pinStyle"
              class="pin-input"
              @input="handleInput($event, 5, null)"
              @keydown="handleKeydown($event, 'pin6', 'pin5')"
            />
          </div>
          <div style="display: flex; align-items: center; justify-content: center; margin-top: 0px; width: 100%;">
                <div class="" style="display: flex; align-items: center; justify-content: center; border: 1px solid #e00b5b3b; width: fit-content; padding: 8px; border-radius: 16px; color: #e00b5b; background-color: #e00b5b17; cursor: pointer; gap: 4px;" @click="handlePaste(null)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style="height: 16px;"><path d="M439.4 96L448 96C483.3 96 512 124.7 512 160L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 160C128 124.7 156.7 96 192 96L200.6 96C211.6 76.9 232.3 64 256 64L384 64C407.7 64 428.4 76.9 439.4 96zM376 176C389.3 176 400 165.3 400 152C400 138.7 389.3 128 376 128L264 128C250.7 128 240 138.7 240 152C240 165.3 250.7 176 264 176L376 176zM256 320C256 302.3 241.7 288 224 288C206.3 288 192 302.3 192 320C192 337.7 206.3 352 224 352C241.7 352 256 337.7 256 320zM288 320C288 333.3 298.7 344 312 344L424 344C437.3 344 448 333.3 448 320C448 306.7 437.3 296 424 296L312 296C298.7 296 288 306.7 288 320zM288 448C288 461.3 298.7 472 312 472L424 472C437.3 472 448 461.3 448 448C448 434.7 437.3 424 424 424L312 424C298.7 424 288 434.7 288 448zM224 480C241.7 480 256 465.7 256 448C256 430.3 241.7 416 224 416C206.3 416 192 430.3 192 448C192 465.7 206.3 480 224 480z" fill="#e00b5b"/></svg>
                  <span style="position: relative; top: 2px;">Paste from clipboard</span>
                </div>
          </div>
      </div>
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      <div v-if="showDebug" class="debug-info">
        PIN: {{ completePin }} ({{ completePin.length }}/{{ length }})
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'PinInput',
    props: {
      value: {
        type: String,
        default: ''
      },
      length: {
        type: Number,
        default: 6
      },
      title: {
        type: String,
        default: 'Authenticator Code'
      },
      placeholder: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      error: {
        type: String,
        default: ''
      },
      showDebug: {
        type: Boolean,
        default: false
      },
      masked: {
        type: Boolean,
        default: true
      },
      containerClass: {
        type: String,
        default: ''
      },
      inputContainerClass: {
        type: String,
        default: ''
      },
      titleClass: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        pin1: '',
        pin2: '',
        pin3: '',
        pin4: '',
        pin5: '',
        pin6: '',
        refs: ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6']
      };
    },
    computed: {
      completePin() {
        return `${this.pin1}${this.pin2}${this.pin3}${this.pin4}${this.pin5}${this.pin6}`;
      },
      pinStyle() {
        return this.masked ? {
          '-webkit-text-security': 'disc',
          'text-security': 'disc'
        } : {};
      }
    },
    watch: {
      completePin: {
        handler(newVal) {
          this.$emit('input', newVal);
          this.$emit('change', newVal);
          if (newVal.length === this.length) {
            this.$emit('complete', newVal);
          }
        },
        immediate: true
      },
      value: {
        handler(newVal) {
          if (newVal !== this.completePin) {
            this.setPin(newVal || '');
          }
        },
        immediate: true
      }
    },
    mounted() {
      this.clearPin();
      this.focusFirst();
    },
    methods: {
      handleInput(event, currentIndex, nextIndex) {
        const value = event.target.value;
        const currentRef = this.refs[currentIndex];
        event.target.value = '';
        if (!/^\d$/.test(value)) {
          this[currentRef] = '';
          return;
        }
        this[currentRef] = value;
        event.target.value = value;
        if (value && nextIndex !== null) {
          this.$nextTick(() => {
            const nextRef = this.refs[nextIndex];
            const nextInput = this.$refs[nextRef];
            if (nextInput) {
              nextInput.focus();
            }
          });
        }
      },
      handleKeydown(event, currentPin, previousPin) {
        if (
          event.key === 'Backspace' &&
          !this.$refs[currentPin].value &&
          previousPin
        ) {
          this.$nextTick(() => {
            this.$refs[previousPin].focus();
          });
        }
      },
      handleFocus(event) {
        event.target.select();
      },
      async handlePaste(event) {
        try {
          let text = '';
          if (event) {
            event.preventDefault();
            text = event.clipboardData.getData('text');
          } else {
            text = await navigator.clipboard.readText();
          }
          const digits = text.replace(/\D/g, '').slice(0, this.length);
          if (!digits) return;
          this.setPin(digits);
          const nextIndex = Math.min(digits.length, this.length - 1);
          this.$nextTick(() => {
            const nextInput = this.$refs[this.refs[nextIndex]];
            if (nextInput) nextInput.focus();
          });
        } catch (err) {
          console.error('Clipboard read failed:', err);
        }
      },
      setPin(pinString) {
        this.clearPin();
        const digits = pinString.split('').slice(0, this.length);
        digits.forEach((digit, index) => {
          if (index < this.refs.length) {
            this[this.refs[index]] = digit;
          }
        });
        this.$nextTick(() => {
          this.refs.forEach((ref) => {
            const input = this.$refs[ref];
            if (input) {
              input.value = this[ref] || '';
            }
          });
        });
      },
      clearPin() {
        this.refs.forEach(ref => {
          this[ref] = '';
        });
        this.$nextTick(() => {
          this.refs.forEach(ref => {
            const input = this.$refs[ref];
            if (input) {
              input.value = '';
            }
          });
        });
      },
      focusFirst() {
        this.$nextTick(() => {
          const firstInput = this.$refs.pin1;
          if (firstInput) {
            firstInput.focus();
          }
        });
      },
      focus() {
        this.focusFirst();
      },
      clear() {
        this.clearPin();
        this.focusFirst();
      }
    }
  };
  </script>
  <style scoped>
  .pin-input-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .pin-input-container-left {
    display: flex;
    flex-direction: column;
  }
  .pin-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    color: #333;
  }
  .pin-title-sm {
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 20px;
  }
  .pin-inputs {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-bottom: 16px;
  }
  .pin-inputs-left {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
  }
  .pin-input {
    width: 50px;
    height: 50px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    background: white;
    outline: none;
    transition: all 0.2s ease;
  }
  .pin-input:focus {
    border-color: #e91e63;
    box-shadow: 0 0 0 3px rgba(233, 30, 99, 0.1);
  }
  .pin-input:disabled {
    background-color: #f5f5f5;
    border-color: #ddd;
    cursor: not-allowed;
  }
  /* Remove browser autofill styling */
  .pin-input:-webkit-autofill,
  .pin-input:-webkit-autofill:hover,
  .pin-input:-webkit-autofill:focus,
  .pin-input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    box-shadow: 0 0 0 30px white inset !important;
    background-clip: content-box !important;
  }
  .pin-input::placeholder {
    color: transparent !important;
    opacity: 0 !important;
  }
  .error-message {
    color: #dc3545;
    font-size: 14px;
    margin-top: 8px;
    text-align: center;
  }
  .debug-info {
    margin-top: 10px;
    padding: 8px 12px;
    background: #f8f9fa;
    border-radius: 4px;
    font-size: 12px;
    color: #6c757d;
    font-family: monospace;
  }
  /* Mobile responsive */
  @media (max-width: 480px) {
    .pin-inputs {
      gap: 8px;
    }
    .pin-input {
      width: 40px;
      height: 40px;
      font-size: 16px;
    }
  }
  </style>
